import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/MISItemTransactionReport';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const MISItemTransactionReport = ({ t }) => (
  <Container>
    <Row>
      <Col md={12} style = {{marginBottom : "-15px"}}>

      </Col>
    </Row>
       
    <Row>
      <HorizontalForm />
    </Row>

   
  </Container>
);

MISItemTransactionReport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(MISItemTransactionReport);
